import { render, staticRenderFns } from "./cookie-policy.vue?vue&type=template&id=c0469dde&scoped=true&"
import script from "./cookie-policy.vue?vue&type=script&lang=js&"
export * from "./cookie-policy.vue?vue&type=script&lang=js&"
import style0 from "./cookie-policy.vue?vue&type=style&index=0&id=c0469dde&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0469dde",
  null
  
)

component.options.__file = "cookie-policy.vue"
export default component.exports